import cn from 'classnames';
import React, { ReactElement, useMemo } from 'react';
import { Vec2 } from 'three';
import { THEME } from '../../config';
import { sortedVesselList } from '../../utils/vessel';
import { getVesselColor } from './helpers';

interface Props {
  mousePosHigh: boolean;
  vessels: string[];
  itemHeight: number;
  itemWidth: number;
  contextMenuPos: Vec2;
  selectedVessel: string;
  changeVessel: (e: React.MouseEvent, vessel: string) => void;
}

const PADDING_PER_ITEM = 6;
const HALF_PADDING_FOR_HORIZONTAL_SHIFT = PADDING_PER_ITEM / 2;

export function CalciumContextSubMenu({
  mousePosHigh,
  vessels,
  itemHeight,
  itemWidth,
  contextMenuPos,
  selectedVessel,
  changeVessel,
}: Props): ReactElement<Props> {
  const { x: leftPos, y: topPos }: Vec2 = useMemo(() => {
    const baseContextMenuBottomPos = itemHeight + PADDING_PER_ITEM;
    const y = mousePosHigh
      ? // Place the sub menu completely above the context menu
        // Account for 3 extra paddings for the sub context menu top, bottom and the top of the
        // context menu
        contextMenuPos.y - baseContextMenuBottomPos * vessels.length - 3 * PADDING_PER_ITEM
      : // Place the sub menu below the context menu
        contextMenuPos.y + baseContextMenuBottomPos;

    const x = contextMenuPos.x - HALF_PADDING_FOR_HORIZONTAL_SHIFT;

    return { x, y };
  }, [mousePosHigh, contextMenuPos, itemHeight, vessels.length]);

  return (
    <div
      style={{
        backgroundColor: THEME.colors.global.black,
        borderRadius: '3px',
        color: THEME.colors.gray[300],
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        position: 'fixed',
        top: topPos,
        left: leftPos,
        width: itemWidth + PADDING_PER_ITEM,
        paddingTop: '3px',
        paddingBottom: '3px',
      }}
    >
      {sortedVesselList(vessels).map((vessel, i) => (
        <div
          className={cn('context-menu__item', 'context-menu__item-option', {
            chosen: vessel.toLowerCase() === selectedVessel.toLowerCase(),
          })}
          key={i}
          onClick={(e) => changeVessel(e, vessel)}
        >
          <span
            style={{
              background: getVesselColor(vessel),
              width: '14px',
              height: '14px',
              borderRadius: '3px',
              paddingRight: '12px',
              marginLeft: '6px',
              display: 'inline-block',
            }}
          />
          <span
            style={{
              height: itemHeight,
              fontSize: '14px',
              fontWeight: 600,
              fontFamily: THEME.fonts.accuminPro,
              width: itemWidth,
              color: THEME.colors.gray[200],
              textAlign: 'left',
              padding: '12px',
            }}
          >
            {vessel}
          </span>
        </div>
      ))}
    </div>
  );
}
